
      var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDataUsage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.866 3.268c-1.047.817-3.14 3.217-3.14 6.278 0 3.06 1.814 5.46 2.721 6.278M17.795 3.268c1.047.817 3.14 3.217 3.14 6.278 0 3.06-1.814 5.46-2.721 6.278M8.621 5.916c-.697.498-1.813 1.863-1.813 3.728 0 1.865 1.209 3.327 1.813 3.825M15.178 5.916c.698.498 1.814 1.863 1.814 3.728 0 1.865-1.209 3.327-1.814 3.825M12 9.273v11.454",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#dataUsage_4dbaacd294d6c259__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9.818,
  r: 2.182,
  fill: "#000"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dataUsage_4dbaacd294d6c259__a",
  x: 7.818,
  y: 5.636,
  width: 8.363,
  height: 8.364,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.783333 0 0 0 0 0 0 0 0 0 1 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_8026_23732"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_8026_23732",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M5.86575 3.26758C4.81935 4.08503 2.72656 6.48507 2.72656 9.54561C2.72656 12.6062 4.54031 15.0062 5.44719 15.8236\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n<path d=\"M17.7954 3.26758C18.8418 4.08503 20.9346 6.48507 20.9346 9.54561C20.9346 12.6062 19.1208 15.0062 18.2139 15.8236\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n<path d=\"M8.62137 5.91602C7.92377 6.41415 6.80762 7.77858 6.80762 9.6436C6.80762 11.5086 8.01678 12.9711 8.62137 13.4693\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n<path d=\"M15.1784 5.91602C15.876 6.41415 16.9922 7.77858 16.9922 9.6436C16.9922 11.5086 15.783 12.9711 15.1784 13.4693\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n<path d=\"M12 9.27295V20.7275\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n<g filter=\"url(#filter0_d_8026_23732)\">\r\n<circle cx=\"12.0002\" cy=\"9.81805\" r=\"2.18182\" fill=\"black\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_8026_23732\" x=\"7.81836\" y=\"5.63623\" width=\"8.36328\" height=\"8.36377\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset/>\r\n<feGaussianBlur stdDeviation=\"1\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0.783333 0 0 0 0 0 0 0 0 0 1 0 0 0 0.1 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_8026_23732\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_8026_23732\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/dataUsage.4dbaacd294d6c259cedf2d8b7e9d0be5.svg"),
        {
          React: SvgDataUsage,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      